import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from '../../components/Common/Select';
import Translation from '../../utilities/localizationUtility';
import { customSelectStyles } from '../../utilities/helperUtility';
import { setOrderDetails } from '../../actions/orders';

class Index extends Component {
  componentDidMount() {
    const { setOrderDetails, depositSettings } = this.props;
    const paymentOption = !depositSettings ? 'payInFull' : 'payDeposit';
    setOrderDetails({ paymentOption: paymentOption });
  }

  options() {
    const t = new Translation(this.props);
    return [
      {
        label: t.key('payDepositLabel') || 'Pay Deposit',
        value: 'payDeposit',
      },
      {
        label: t.key('payInFullLabel') || 'Pay in Full',
        value: 'payInFull',
      }
    ]
  }

  translation() {
    return new Translation(this.props);
  }

  render() {
    const { depositSettings, depositAllowed } = this.props;
    if (!depositSettings?.allow_full_payment || !depositAllowed) return;

    const { setOrderDetails, style: { body }, styles } = this.props;
    const label = this.translation().key('paymentOptionsLabel') || 'Payment Options';

    return (
      <div className='select-block payment-options-container' >
        <span className='titles' style={{ ...body }}>{label}</span>
        <Select
          name="payment_options"
          value={this.props.paymentOption}
          options={this.options()}
          styles={styles}
          isSearchable={false}
          allowSelectOption
          onChange={x => setOrderDetails({ paymentOption: x })}
        />
      </div>
    );
  }
}

export default connect(
  ({ order, product, settings }) => ({
    defaultTranslation: settings.defaultTranslation,
    depositSettings: settings.depositSettings,
    paymentOption: order.paymentOption,
    depositAllowed: product.data.deposit_allowed,
    styles: customSelectStyles(settings.style.select),
    style: settings.style,
    translation: settings.translation
  }),
  (dispatch) => ({
    setOrderDetails: (value) => dispatch(setOrderDetails(value)),
  }),
)(Index);
